/* ============================================================
   NORTHSHEEP — dynamic card shadow (EXPERIMENT)
   Scroll sweeps the shadow down the RIGHT side of every collection card:

     scroll top    -> shadow at the TOP-RIGHT of the card
     scroll middle -> shadow at the MIDDLE-RIGHT
     scroll bottom -> shadow at the BOTTOM-RIGHT

   The shadow stays on the right (offset X constant) and its vertical offset
   moves from up (top) to down (bottom) with scroll position. All cards share
   the same shadow (parallel, like one light source).

   Performance: sets CSS variables on :root per frame (cards inherit them),
   rAF-throttled, reduced-motion-safe. Blur/alpha are constant, so the only
   thing changing each frame is the Y offset — cheap. Tunables below.
   Remove this file + its <script> tag + the "(D)" CSS block to undo.
   ============================================================ */
(function () {
  // Several sections include this file; a second run would bind a second pair
  // of scroll/resize listeners doing the same work.
  if (window.__nsCardShadow) return;
  window.__nsCardShadow = true;

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  /* Devices that cannot hover (phones, tablets without a mouse): collection
     cards skip rendering while off screen there (content-visibility,
     northsheep-collection.css — owner, 2026-09-15), which would clip this
     shadow, so it is switched off on those devices. Don't keep a scroll
     listener restyling every card for a shadow nobody can see. */
  if (window.matchMedia && window.matchMedia('(hover: none) and (pointer: coarse)').matches) {
    return;
  }

  var SIDE = 18; // constant rightward offset — shadow stays on the right (px)
  var MAX_V = 26; // vertical sweep amplitude: -MAX_V (top) .. +MAX_V (bottom) (px)
  var BLUR = 30; // constant softness (px) — softer spread, lower contrast
  var ALPHA = 0.1; // constant darkness — subtle

  var root = document.documentElement;
  var ticking = false;
  var lastY = '';

  /* ONLY WHAT CHANGED, ONLY WHEN IT CHANGED (audit, 23 Sep 2026).

     These are custom properties on <html>, and every element inherits them,
     so each write asks the browser to restyle the whole document — about
     10,000 elements on a collection page — and repaint every card's blurred
     shadow. It used to write all four on every scroll frame, three of them
     constants. Now the constants are written once, and the one moving value
     only when its rounded figure actually changes: the sweep is 52px over the
     whole page, so that is every few dozen pixels of scrolling instead of
     every frame. The shadow looks exactly the same. */
  function update() {
    ticking = false;

    var max = root.scrollHeight - window.innerHeight;
    if (max < 1) max = 1;
    var p = (window.scrollY || window.pageYOffset || 0) / max;
    if (p < 0) p = 0;
    else if (p > 1) p = 1;

    // X stays on the right; Y sweeps from up (top) to down (bottom).
    var y = (-MAX_V + p * (2 * MAX_V)).toFixed(1) + 'px';
    if (y !== lastY) {
      lastY = y;
      root.style.setProperty('--ns-shadow-y', y);
    }
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(update);
    }
  }

  function init() {
    /* AND NOT AT ALL WHEN NO CARD SHOWS IT. The card tint (Theme settings →
       Northsheep product cards) zeroes the resting shadow's alpha on every
       card — ns-card-tint.css, "NO RESTING SHADOW ON THE CARDS" — so with it
       on, this listener restyled the page on every scroll frame for a shadow
       nobody could see. Read from a real card, so any setting or stylesheet
       that hides the shadow counts, and turning the tint off brings the
       sweep straight back. */
    var card = document.querySelector('.product-card-wrapper .card');
    if (card && parseFloat(getComputedStyle(card).getPropertyValue('--ns-shadow-alpha')) === 0) return;

    root.style.setProperty('--ns-shadow-x', SIDE.toFixed(1) + 'px');
    root.style.setProperty('--ns-shadow-blur', BLUR.toFixed(1) + 'px');
    root.style.setProperty('--ns-shadow-alpha', ALPHA.toFixed(3));
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
